// ═══════════════════════════════════════════════════════════════════════════
// AUREUS FLOW — tarification du module autonome (Planning + Pointeuse GPS +
// écart Prévu/Réel), loué à des sociétés qui ne sont PAS clientes paie
// d'Aureus Social Pro (décision fondateur 27/09/2026 : « je loue même ceux
// qui n'ont pas Aureus Social »).
//
// ⚠️ PROVISOIRE — prix non validé par le fondateur. Sa phrase exacte :
// « on reviendra sur les prix plus tard ». Les deux constantes ci-dessous se
// changent ICI SEULEMENT (R14 bis) : catalogue-services.js les importe,
// aucune facturation future ne les recopie.
// ═══════════════════════════════════════════════════════════════════════════

// €/société/mois, quel que soit l'effectif — couvre le compte, le
// paramétrage du secteur/CP, l'infrastructure.
export const FLOW_SOCLE_MENSUEL = 29;

// €/travailleur PLANIFIÉ actif ce mois-ci (pas l'effectif total) — couvre
// Planning + Pointeuse GPS + écart Prévu/Réel + alertes.
export const FLOW_PRIX_TRAVAILLEUR = 4;

// Essai découverte, sans carte — aligné sur le standard du marché (Skello,
// Combo, Deputy proposent tous un essai gratuit).
export const FLOW_ESSAI_JOURS = 14;

/**
 * Calcule la facture mensuelle Aureus Flow pour un client.
 * @param {number} nbTravailleursPlanifies — travailleurs ayant au moins un
 *   shift planifié ce mois-ci. Jamais l'effectif total : un travailleur au
 *   repos ou pas encore repris dans le planning n'est pas compté.
 */
export function calculerFactureFlow(nbTravailleursPlanifies = 0) {
  const n = Math.max(0, Math.round(Number(nbTravailleursPlanifies) || 0));
  const variable = Math.round(n * FLOW_PRIX_TRAVAILLEUR * 100) / 100;
  const total = Math.round((FLOW_SOCLE_MENSUEL + variable) * 100) / 100;
  return { socle: FLOW_SOCLE_MENSUEL, prixTravailleur: FLOW_PRIX_TRAVAILLEUR, nbTravailleurs: n, variable, total };
}
